import { createRouter, createWebHistory } from "vue-router";
import store from "@src/store";

// Import Layout
const FrontendTemplate = () => import("../layouts/Frontend.vue");
const UserTemplate = () => import("../layouts/User.vue");
const PadelUserTemplate = () => import("../layouts/PadelUser.vue");

// GENERAL - Auth Page (Frontend)
const Login = () => import("../views/auth/frontend/Login.vue");
const Register = () => import("../views/auth/frontend/Register.vue");
const ForgotPassword = () =>
  import("../views/auth/frontend/ForgotPassword.vue");
const ResetPassword = () => import("../views/auth/frontend/ResetPassword.vue");

// GENERAL - Profile Page (Frontend)
const Profile = () => import("../views/profile/Profile.vue");
const ProfilePadel = () => import("../views/profile/ProfilePadel.vue");
const EditProfile = () => import("../views/profile/EditProfile.vue");
const ChangePassword = () => import("../views/profile/ChangePassword.vue");
const PointsDashboard = () => import("../views/profile/PointsDashboard.vue");

// Points Pages
const PurchaseForm = () => import("../views/points/PurchaseForm.vue");
const PurchaseSuccess = () => import("../views/points/PurchaseSuccess.vue");
const PurchaseFailed = () => import("../views/points/PurchaseFailed.vue");
const TopupSuccess = () => import("../views/points/TopupSuccess.vue");
const TopupFailed = () => import("../views/points/TopupFailed.vue");
const PointsLedger = () => import("../views/points/PointsLedger.vue");

// GENERAL - Booking Calendar Page
const BookingCalendarFront = () => import("../views/BookingCalendarPage.vue");
const BookingCalendarTennisFront = () =>
  import("../views/BookingCalendarTennisPage.vue");
const BookingCalendarPadelFront = () =>
  import("../views/BookingCalendarPadelPage.vue");

// TENNIS - Frontend
const IndexPage = () => import("../views/Index.vue");
const Home = () => import("../views/frontend/Home.vue");
const Addon = () => import("../views/frontend/Addon.vue");
const AuthUser = () => import("../views/frontend/Auth.vue");
const Summary = () => import("../views/frontend/Summary.vue");
const ExtraAddon = () => import("../views/frontend/extraaddon/ExtraAddon.vue");
const ExtraSummary = () =>
  import("../views/frontend/extraaddon/ExtraSummary.vue");
const SummaryGuest = () => import("../views/frontend/guest/Summary.vue");
const BookingCompletedGuest = () =>
  import("../views/frontend/guest/BookingCompleted.vue");

// PADEL - Frontend
const PadelHome = () => import("../views/frontend_padel/Home.vue");
const PadelAddon = () => import("../views/frontend_padel/Addon.vue");
const PadelAuthUser = () => import("../views/frontend_padel/Auth.vue");
const PadelSummary = () => import("../views/frontend_padel/Summary.vue");
const PadelExtraAddon = () =>
  import("../views/frontend_padel/extraaddon/ExtraAddon.vue");
const PadelExtraSummary = () =>
  import("../views/frontend_padel/extraaddon/ExtraSummary.vue");
const PadelSummaryGuest = () =>
  import("../views/frontend_padel/guest/Summary.vue");
const PadelBookingCompletedGuest = () =>
  import("../views/frontend_padel/guest/BookingCompleted.vue");

// Page Error
const ErrorPage = () => import("../views/ErrorView.vue");

const routes = [
  {
    name: "Login",
    path: "/login",
    meta: {
      middleware: "guest",
      title: `Login`,
    },
    component: Login,
  },
  {
    name: "Register",
    path: "/register",
    meta: {
      middleware: "guest",
    },
    component: Register,
  },
  {
    name: "ForgotPassword",
    path: "/forgot-password",
    component: FrontendTemplate,
    meta: {
      middleware: "guest",
    },
    redirect: { name: "ForgotPasswordUser" },
    children: [
      {
        name: "ForgotPasswordUser",
        path: "/forgot-password",
        component: ForgotPassword,
      },
    ],
  },
  {
    name: "ResetPassword",
    path: "/reset-password",
    component: FrontendTemplate,
    meta: {
      middleware: "guest",
    },
    redirect: { name: "ResetPasswordUser" },
    children: [
      {
        name: "ResetPasswordUser",
        path: "/reset-password/:token",
        component: ResetPassword,
      },
    ],
  },
  {
    name: "Profile",
    path: "/profile",
    component: FrontendTemplate,
    meta: {
      middleware: "user",
    },
    redirect: { name: "ProfileUser" },
    children: [
      {
        name: "ProfileUser",
        path: "/profile",
        component: Profile,
      },
      {
        name: "ProfilePadelUser",
        path: "/profile-padel",
        component: ProfilePadel,
      },
      {
        name: "EditProfileUser",
        path: "/edit-profile",
        component: EditProfile,
      },
      {
        name: "ChangePasswordUser",
        path: "/change-password",
        component: ChangePassword,
      },
      {
        name: "PointsDashboard",
        path: "/points",
        component: PointsDashboard,
      },
    ],
  },
  {
    name: "Points",
    path: "/points",
    component: FrontendTemplate,
    meta: {
      middleware: "user",
      requiresAuth: true,
    },
    redirect: { name: "PurchaseForm" },
    children: [
      {
        name: "PurchaseForm",
        path: "/points/purchase",
        component: PurchaseForm,
      },
      {
        name: "PurchaseSuccess",
        path: "/points/purchase/success/:transactionId",
        component: PurchaseSuccess,
      },
      {
        name: "PurchaseFailed",
        path: "/points/purchase/failed/:transactionId",
        component: PurchaseFailed,
      },
      {
        name: "PointsLedger",
        path: "/points/ledger",
        component: PointsLedger,
      },
    ],
  },
  {
    name: "TopupSuccess",
    path: "/points/purchase/success",
    // component: FrontendTemplate,
    meta: {
      middleware: "user",
      requiresAuth: true,
    },
    children: [
      {
        name: "TopupSuccessPage",
        path: "/points/purchase/success",
        component: TopupSuccess,
      },
    ],
  },
  {
    name: "TopupFailed",
    path: "/points/purchase/failed",
    // component: FrontendTemplate,
    meta: {
      middleware: "user",
      requiresAuth: true,
    },
    children: [
      {
        name: "TopupFailedPage",
        path: "/points/purchase/failed",
        component: TopupFailed,
      },
    ],
  },
  {
    name: "IndexPage",
    path: "/",
    component: IndexPage,
    meta: {
      middleware: "user",
    },
  },
  {
    name: "BookingCalendarFront",
    path: "/court-schedules",
    component: BookingCalendarFront,
    meta: {
      middleware: "user",
    },
  },
  {
    name: "BookingCalendarTennisFront",
    path: "/court-schedules-tennis",
    component: BookingCalendarTennisFront,
    meta: {
      middleware: "user",
    },
  },
  {
    name: "BookingCalendarPadelFront",
    path: "/court-schedules-padel",
    component: BookingCalendarPadelFront,
    meta: {
      middleware: "user",
    },
  },
  {
    name: "SummaryGuestUser",
    path: "/guest/summary",
    component: SummaryGuest,
    meta: {
      middleware: "guest",
    },
  },
  {
    name: "OrderCompletedGuestUser",
    path: "/guest/booking-completed",
    component: BookingCompletedGuest,
    meta: {
      middleware: "guest",
    },
  },
  {
    name: "PadelSummaryGuestUser",
    path: "/padel/guest/summary",
    component: PadelSummaryGuest,
    meta: {
      middleware: "guest-padel",
    },
  },
  {
    name: "PadelOrderCompletedGuestUser",
    path: "/padel/guest/booking-completed",
    component: PadelBookingCompletedGuest,
    meta: {
      middleware: "guest-padel",
    },
  },
  {
    name: "Home",
    path: "/home",
    component: UserTemplate,
    meta: {
      middleware: "user",
    },
    redirect: { name: "HomeUser" },
    children: [
      {
        name: "HomeUser",
        path: "/tennis",
        component: Home,
      },
      {
        name: "AddonUser",
        path: "/addon",
        component: Addon,
      },
      {
        name: "SummaryUser",
        path: "/summary",
        component: Summary,
      },
      {
        name: "AuthUser",
        path: "/auth",
        component: AuthUser,
      },
      {
        name: "ExtraAddonUser",
        path: "/extra-addon/:order_id",
        component: ExtraAddon,
      },
      {
        name: "ExtraSummaryUser",
        path: "/extra-summary/:order_id",
        component: ExtraSummary,
      },
    ],
  },
  {
    name: "PadelHome",
    path: "/padel",
    component: PadelUserTemplate,
    meta: {
      middleware: "user_padel",
    },
    redirect: { name: "PadelHomeUser" },
    children: [
      {
        name: "PadelHomeUser",
        path: "/padel",
        component: PadelHome,
      },
      {
        name: "PadelAddonUser",
        path: "/padel/addon",
        component: PadelAddon,
      },
      {
        name: "PadelSummaryUser",
        path: "/padel/summary",
        component: PadelSummary,
      },
      {
        name: "PadelAuthUser",
        path: "/padel/auth",
        component: PadelAuthUser,
      },
      {
        name: "PadelExtraAddonUser",
        path: "/padel/extra-addon/:order_id",
        component: PadelExtraAddon,
      },
      {
        name: "PadelExtraSummaryUser",
        path: "/padel/extra-summary/:order_id",
        component: PadelExtraSummary,
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    name: "ErrorPage",
    component: ErrorPage,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes, // short for `routes: routes`
  scrollBehavior() {
    // return { top: 0, left: 0 }
    window.scrollTo(0, 0);
  },
});

// store.state.sport.type
router.beforeEach((to, from, next) => {
  // Guard: requiresAuth routes redirect to Login if not authenticated
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.state.auth.user_authenticated) {
      next({ name: "Login", query: { redirect: to.fullPath } });
      return;
    }
  }

  if (to.meta.middleware == "user") {
    if (store.state.auth.user_authenticated) {
      if (to.matched.some(({ name }) => name === "AuthUser")) {
        next({ name: "SummaryUser" });
      } else {
        next();
      }
    } else {
      next();
    }
  } else if (to.meta.middleware == "user_padel") {
    if (store.state.auth.user_authenticated) {
      if (to.matched.some(({ name }) => name === "PadelAuthUser")) {
        next({ name: "PadelSummaryUser" });
      } else {
        next();
      }
    } else {
      next();
    }
  } else if (to.meta.middleware == "guest") {
    if (store.state.auth.user_authenticated) {
      next({ name: "ProfileUser" });
    } else {
      next();
    }
  } else if (to.meta.middleware == "guest-padel") {
    if (store.state.auth.user_authenticated) {
      next({ name: "ProfileUser" });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
